import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyAc-PPiFTET-MhBlkDrsa3-WvQpNSiahAA",
  authDomain: "accountability-566c2.firebaseapp.com",
  projectId: "accountability-566c2",
  storageBucket: "accountability-566c2.firebasestorage.app",
  messagingSenderId: "168171912691",
  appId: "1:168171912691:web:c0b5674b8c2e59fbb5e686"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const APP_ID = 'za-blueprint-final';
